import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import LearningMaterialForm from '../../components/LearningMaterial/LearningMaterialForm';
import { getAuthoringAssistantCreateState } from '../../components/AI/authoringAssistantNavigation';

const MaterialCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { courseId, lessonId } = useParams<{ courseId: string; lessonId: string }>();
  const parsedLessonId = lessonId ? parseInt(lessonId, 10) : null;
  const assistantCreateState = getAuthoringAssistantCreateState(location.state, 'material');

  if (!parsedLessonId || !courseId || !lessonId) {
    return null;
  }

  return (
    <div>
      <Breadcrumb courseId={courseId} lessonId={lessonId} additionalCrumb="Uusi materiaali *" />
      <h1>Luo uusi materiaali</h1>
      <LearningMaterialForm
        lessonId={parsedLessonId}
        onSave={() => navigate(`/course/${courseId}/lesson/${lessonId}`)}
        onCancel={() => navigate(`/course/${courseId}/lesson/${lessonId}`)}
        assistantInitialPrompt={assistantCreateState.prompt}
        assistantAutoGenerate={assistantCreateState.autoGenerate}
      />
    </div>
  );
};

export default MaterialCreatePage;